// Availability.js

import axiosInstance from '@/lib/axios';


const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  return {
    'Authorization': `${tokenType} ${token}`,
    'Content-Type': 'application/json',
  };
};



export async function calendarGET(selected_date) {
  try {
    const response = await axiosInstance.get(`/appointments/calendar/${selected_date}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}



export async function deleteAppointment(conversation_id) {

  try {
    const response = await axiosInstance.delete(`/appointments/${conversation_id}`, {
      headers: getAuthHeaders(),
      data: { type: "conversation" } // pass payload as an object
    });


    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
}

